module.exports = __webpack_public_path__ + "static/img/20180414165855.6dee59da.jpg";